import Instance from '../../../Axios';

// New Actions for the app

const GetCategoriasProduto = () => async (dispatch) => {
  await Instance()
    .get(`/backend/produtos/categorias`)
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'GET_CATEGORIAS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCategoriasProduto;
